// extracted by mini-css-extract-plugin
module.exports = {"card":"cityCard_card__15LDz","icon":"cityCard_icon___wFN0","name":"cityCard_name__3Uow1"};